import { render, staticRenderFns } from "./ClassifyDocuments.vue?vue&type=template&id=417ee680&scoped=true"
import script from "./ClassifyDocuments.vue?vue&type=script&lang=js"
export * from "./ClassifyDocuments.vue?vue&type=script&lang=js"
import style0 from "./ClassifyDocuments.vue?vue&type=style&index=0&id=417ee680&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417ee680",
  null
  
)

export default component.exports